import SearchResultEntity from "../../../../../domain/entities/SearchResultEntity";
import UserEntity from "../../../../../domain/entities/UserEntity";

//TODO implement
const SearchUsersOfShiftApiImpl = (shiftId: string, word: string, page: number, itemsPerPage: number): Promise<SearchResultEntity<UserEntity>> => {
    throw new Error('Method not implemented.');
}

export default SearchUsersOfShiftApiImpl;